import { FC } from "react"
import classNames from "classnames"
import { Icon, IconColor, IconProps } from "@/components/shared/Icon"

interface VitalInfoCardProps {
   iconName: IconProps["name"]
   title: string
   value: string | number
   valueUnit: string
   avgValue: string | number
   avgLabel: string
   avgSubLabel: string
}

export const VitalInfoCard: FC<VitalInfoCardProps> = ({
   iconName,
   title,
   value,
   valueUnit,
   avgValue,
   avgLabel,
   avgSubLabel,
}) => (
   <div className="inmate-detail-overview__section">
      <div className="inmate-detail-overview__section-header">
         <span className="inmate-detail-overview__section-title">
            <Icon
               name={iconName}
               size="24"
               color={IconColor.HONOLULU_BLUE}
            />
            <span>{title}</span>
         </span>
      </div>
      <div className="inmate-detail-overview__section-body">
         <span
            className={classNames("inmate-detail-overview__section-value", {
               "inmate-detail-overview__section-value--invalid": value === "-",
            })}
         >
            {value}
            <span className="inmate-detail-overview__section-unit">
               {valueUnit}
            </span>
         </span>
         <span
            className={classNames("inmate-detail-overview__section-value", {
               "inmate-detail-overview__section-value--invalid":
                  avgValue === "-",
            })}
         >
            {avgValue}
            <span className="inmate-detail-overview__section-unit">
               {avgLabel}
               <span className="inmate-detail-overview__section-subunit">
                  {avgSubLabel}
               </span>
            </span>
         </span>
      </div>
   </div>
)
